const store = {
    namespaced: true,
    state: {
        availableLanguages: [],
        currencies: [],
        errorsHandler: {},
        globalLoading: false,
        weightUnits: [],
        dimensionUnits: [],
        unitColumns: [],
        unitAmountPrecisionList: [],
    },
    getters: {
        getUnitAmountPrecisionList(state) {
            return state.unitAmountPrecisionList;
        },
        getUnitColumns(state) {
            return state.unitColumns;
        },
        getDimensionUnits(state) {
            return state.dimensionUnits;
        },
        getWeightUnits(state) {
            return state.weightUnits;
        },
    },
    mutations: {
        toggleLoading(state) {
            state['globalLoading'] = !state['globalLoading'];
        },
        startLoading(state) {
            state['globalLoading'] = true;
        },
        stopLoading(state) {
            state['globalLoading'] = false;
        },
    },
    actions: {
        toggleLoading({ commit }) {
            commit('toggleLoading');
        },
        startLoading({ commit }) {
            commit('startLoading');
        },
        stopLoading({ commit }) {
            commit('stopLoading');
        },
    },
};

const factory = (system = {}) => {
    return {
        ...store,
        state: {
            availableLanguages: system.availableLanguages,
            currencies: system.currencies,
            errorsHandler: system.errorsHandler,
            reCaptchav3: system.reCaptchav3,
            globalLoading: false,
            weightUnits: system.weightUnits,
            dimensionUnits: system.dimensionUnits,
            unitColumns: system.unitColumns,
            unitAmountPrecisionList: system.unitAmountPrecisionList,
        },
    };
};

export { store as default, factory };
